<template>
  <div>
    <section class="text-gray-700">
      <div class="container px-4 py-24 mx-auto">
        <div class="text-center mb-20">
          <h1
            class="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4"
          >
            <b>F</b>requently <b>A</b>sked <b>Q</b>uestion
          </h1>
          <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
            Some Inspiring Facts About The Pursuit Of Happyness.
          </p>
        </div>
        <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2 text-left">
          <div class="w-full lg:w-1/2 px-4 py-2">
            <details class="mb-4">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Why is Happiness spelled wrong in the title?
              </summary>

              <span class="mt-2 ml-4">
                The word <b>happiness</b> in the title is <b>deliberately misspelled</b>,
                just as it was on the wall of a day care center where Gardner
                once sought care for his young son, Chris Jr., during some of
                his worst days." Chris (Will Smith) even points out the
                misspelling to the Chinese care-giver that the mural decorating
                his son's daycare is spelled incorrectly. Chris wanted to make
                sure that his son was taught things the correct way, so that he
                could grow up to be an educated man and make something great of
                himself. Chris <b>took offense</b> to the fact that the world
                happiness was spelled wrong on the wall and became irritated by
                it. <b>But the word comes to signify Chris' own pursuit of
                <span class="line-through">happiness</span> happyness</b>.
              </span>
            </details>
            <details class="mb-4">
              <summary class="font-semibold bg-gray-200 rounded-md py-2 px-1">
                Is there a real Chris Gardner?
              </summary>

              <span class="mt-2 ml-4">
                The Pursuit of Happyness is based on the <b>real story</b> of a
                Milwaukee-born man named <b>Paul Gardner</b> (born February 9,
                1954), who struggled in the early 1980s to make ends meet while
                raising his toddler son. Just as Chris Gardner in the movie,
                played impeccably by Will Smith, the real story of Christopher
                Gardner is one about <b>overcoming hardship</b> to eventually
                become successful in life. This story is a true inspiration and
                serves as a prime example of
                <b>how we must overcome difficulties, not be overcome by them</b
                >.
                <img
                  src="https://qphs.fs.quoracdn.net/main-qimg-adec548f5ab584a1a6c0d408e9cb8b58"
                />
              </span>
            </details>
            <details class="mb-4">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Are any of the co-stars related?
              </summary>

              <span class="mt-2 ml-4">
                One of the most remarkable facts about
                <b>The Pursuit of Happyness</b> is that it actually stars
                <b>father and son in real life</b> as well. If you wonder how
                the two main characters were able to pull off such a
                <b>realistic connection</b> as father and son, this is the
                answer! <b>Will Smith and his son Jaden Smith</b> play the roles
                of
                <b
                  >Christopher Gardner and his son Christopher Jarrett Medina
                  Gardner</b
                >.
                <img src="https://hips.hearstapps.com/hbz.h-cdn.co/assets/17/15/1492024778-hbz-will-jaden-smith-index.jpg" alt="Will Smith and Jaden Smith - Father and Son">
              </span>
            </details>
            <details class="mb-4">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Did the wife of Gardner ever return?
              </summary>

              <span class="mt-2 ml-4">
                <b>No</b>, she didn't return. <br />I think it was suggested
                from the plot that there came a point of <b>no-return</b> where
                she couldn't take it anymore and moved on. She had also left his
                son behind with Gardner and that was quite surprising as she had
                a job unlike her husband. She knew it very well that she was in
                a position to give their son a better life as compared to her
                husband at that moment of time. It was like leaving everything
                associated with him whether it was her own son. She
                <b>moved on with her life</b> and Gardner has also accepted that
                fact.
              </span>
            </details>
            <details>
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                What is the Timeline of the movie?
              </summary>

              <span class="mt-2 ml-4">
                <ul style="list-style-type:disc;" class="ml-10">
                  <li><b>1981</b> - Chris Gardner invests in scanners</li>
                  <li><b>Jan 1, 1982</b> - Chris Gardner sends his application to Jay Twistle</li>
                  <li><b>Feb 2, 1982</b> - Chris Gardner talks to Jay Twistle and solves a rubiks cube in a Taxi</li>
                  <li><b>Mar 3, 1982</b> - Linda leaves Chris</li>
                  <li><b>May 5, 1982</b> - Chris goes to jail</li>
                  <li><b>Jun 6, 1982</b> - Chris gets invited to the internship</li>
                  <li><b>Jul 7, 1983</b> - Chris completes the internship</li>
                </ul>
              </span>
            </details>
          </div>
          <div class="w-full lg:w-1/2 px-1 py-2">
            <details class="mb-4 ml-3 mr-3">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                How did Chris Gardner become so <b>rich</b>?
              </summary>

              <span class="px-1 py-4 ml-4">
                The movie ends when Christopher Gardner is offered a full-time
                job at the company he followed the <b>internship training</b>.
                This moment is basically only the start of the major change in
                Gardner’s life, the moment he can
                <b>finally provide for his son</b> and live a normal life. After
                a <b>5-year career working</b> as an employee in a
                <b>brokerage firm</b>, he decided to set up his own brokerage
                company called <b>“Gardner Rich &amp; Co,”</b> in
                <b>Chicago, Illinois</b>. <b>“Rich”</b> in the company name
                refers to <b>“Marc Rich”</b>, who Gardner considered being one
                of the most successful futures traders in history. The man
                wasn’t associated with the company in any way though.
                <img src="https://www.5-sterne-redner.de/typo3temp/GB/9e867b588c.jpg" alt="Chris Gardner speaking on stage">
              </span>
            </details>
            <details class="mb-4 ml-3 mr-3">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Was there any <b>Oscar</b> nomination?
              </summary>

              <span class="px-1 py-4 ml-4">
                <b>Yes</b>, Will Smith was nominated for an <b>Oscar</b> and a
                <b>Golden Globe for Best Actor</b>.
              </span>
            </details>
            <details class="mb-4 ml-3 mr-3">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Did the real Chris Gardner appear in the movie?
              </summary>

              <span class="px-1 py-4 ml-4">
                Yes, the real Chris Gardner had a <b>short appearance</b> in the
                movie. At the <b>very end</b> of the movie, the real Chris
                Gardner walks confidently past Will Smith and Jaden. Will Smith
                briefly looks back and smiles at him as he and his son leisurely
                stroll around the streets of San Francisco.
                <img src="https://i.redd.it/ss45k2b5m8l41.jpg" alt="Chris Gardner cameo in The Pursuit of Happyness">
              </span>
            </details>
            <details class="mb-4 ml-3 mr-3">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                What lessons can we learn from this movie?
              </summary>

              <span class="px-1 py-4 ml-4">
                This movie has taught me many life lessons. Some are:-
                <ul style="list-style-type:square;" class="ml-10">
                  <li>
                    Believe in yourself even if others don't believe in you.
                  </li>
                  <li>Set-backs should not stop you from rising.</li>
                  <li>Never give up and keep trying.</li>
                  <li>
                    Importance of RELATIONSHIPS. A beautiful father and son
                    relationship is shown in the movie.
                  </li>
                  <li>DREAM.</li>
                </ul>
              </span>
            </details>
            <details class="mb-4 ml-3 mr-3">
              <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-1">
                Where can I watch "The Pursuit of Happyness"?
              </summary>
              <span class="px-1 py-4 ml-4">
                You can watch the movie in:
                <ol style="list-style-type:circle;" class="ml-10">
                <li><a class="text-blue-700 hover:text-red-500 hover:underline" href="https://www.primevideo.com/detail/0MW4Y2G0VYCAN9FD9NU3J3RA0U/ref=atv_dl_rdr">Amazon Prime Video</a></li>
                </ol>
              </span>
            </details>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
